import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { AdminFeedbackDetailsPage } from "./AdminFeedbackDetailsPage";
import { AdminFeedbackList } from "./AdminFeedbackList";

export const AdminFeedbackPage: FC = () => {
	return (
		<Routes>
			<Route index element={<AdminFeedbackList />} />
			<Route path=":feedbackId/details" element={<AdminFeedbackDetailsPage />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
